<template>
  <div>
    <!-- <van-nav-bar
      title="编辑基本信息"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    >
    </van-nav-bar> -->
    <van-form @submit="submit" class="form">
      <div class="user-img" @click="avatarType = true">
        <!-- <van-icon name="bianji"></van-icon> -->
        <!-- <van-uploader
          v-model="fileList"
          multiple
          :max-count="1"
          :before-read="beforeRead"
          :after-read="PicOnlyReady"
        /> -->
        <!-- <div class="user-cont"> -->
        <van-icon name="bianji"></van-icon>
        <img :src="userInfo.avatar" />
      </div>
      <van-cell-group class="form-cont">
        <van-field
          input-align="right"
          label="姓名"
          v-model="userInfo.name"
          placeholder="请输入姓名"
          required
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          readonly
          input-align="right"
          label="性别"
          required
          :rules="[{ required: true, message: '请选择性别' }]"
        >
          <template #input>
            <van-radio-group v-model="userInfo.sex" direction="horizontal">
              <van-radio :name="1">先生 Mr</van-radio>
              <van-radio :name="0">女士 Ms</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          input-align="right"
          readonly
          @click="selectChange(userInfo.birthday, true)"
          is-link
          :value="userInfo.birthday"
          label="出生年月"
          clickable
          placeholder="请选择出生年月"
          required
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>

        <van-field
          input-align="right"
          label-width="100px"
          readonly
          :value="userInfo.workStartTime"
          label="参加工作时间"
          @click="selectChange(userInfo.workStartTime)"
          is-link
          placeholder="参加工作时间"
          required
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>
        <van-field
          input-align="right"
          label="手机号"
          readonly
          v-model="userInfo.mobile"
        />
        <van-field
          input-align="right"
          label="电子邮箱"
          v-model="userInfo.email"
        />
      </van-cell-group>
      <div class="fixed-bottom">
        <van-button
          type="primary"
          class="btn-blue"
          color="linear-gradient(to right top, #2F72F6,#1C54CF)"
          round
          native-type="submit"
          >保 存</van-button
        >
      </div>
    </van-form>
    <!--头像类型弹框-->
    <van-action-sheet
      v-model="avatarType"
      cancel-text="取消"
      close-on-click-action
      @cancel="onCancel"
      @select="onSelect"
      style="min-height: auto;"
    >
      <van-uploader
        multiple
        :max-count="1"
        :before-read="beforeRead"
        :after-read="PicOnlyReady"
        class="van-action-sheet__item"
      >
        <span class="van-action-sheet__name">相册选择</span>
      </van-uploader>
      <button
        type="button"
        class="van-action-sheet__item"
        @click="avatarSelect = true"
      >
        <span class="van-action-sheet__name">个性头像</span>
      </button>
    </van-action-sheet>
    <!--个性头像-->
    <van-action-sheet
      v-model="avatarSelect"
      title="个性头像"
      cancel-text="取消"
      close-on-click-action
      style="min-height: auto;"
    >
      <ul class="avatar">
        <li v-for="item in module.avatarList" :key="item.index">
          <img :src="item.avatar" @click="getAvatar(item.avatar)" />
        </li>
      </ul>
    </van-action-sheet>
    <!--选择生日-->
    <van-popup v-model="selectbirth" position="bottom" style="width: 100%;">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择时间"
        @cancel="selectbirth = false"
        @confirm="onConfirmBirth"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "basicInfo",
  data() {
    return {
      id: this.$route.query.id,
      userInfo: {},
      active: 0,
      radio: "1",
      value: "",
      avatarType: false,
      avatarSelect: false,
      // minDate: new Date(1900, 0, 1),
      // maxDate: moment().subtract(12 * 16, "month")._d,
      currentDate: "",
      selectbirth: false,
      whatShow: "",
      fileList: []
    };
  },
  computed: {
    minDate() {
      return !this.whatShow
        ? moment(this.userInfo.birthday).add(12 * 16, "month")._d
        : new Date(1900, 0, 1);
    },
    maxDate() {
      return this.whatShow
        ? moment().subtract(12 * 16, "month")._d
        : new Date();
    }
  },
  methods: {
    moment,
    onload(id) {
      this.module.api.personalDetail({
        params: { id },
        success: res => {
          res.birthday = moment(res.birthday).format("YYYY-MM-DD");
          res.workStartTime = moment(res.workStartTime).format("YYYY-MM-DD");
          this.userInfo = res;
          this.fileList.push({ url: res.avatar });
        }
      });
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    selectChange(val, type) {
      this.currentDate = new Date(val);
      this.whatShow = type;
      this.minDate = this.userInfo.birthday
        ? new Date(this.userInfo.birthday)
        : new Date(1900, 0, 1);
      this.$nextTick(() => {
        this.selectbirth = true;
      });
    },
    onCancel() {
      this.avatarType = false;
    },
    getAvatar(avatar) {
      this.$set(this.userInfo, "avatar", avatar);
      this.onCancel();
      this.avatarSelect = false;
    },
    onSelect(item) {
      if (item.name === "个性头像") {
        this.avatarSelect = true;
      }
    },
    beforeRead(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.toast("请上传 jpg/png 格式图片");
        return false;
      }
      // let isLt1M = file.size / 1024 / 1024 <= 1
      // if (!isLt1M) {
      //     this.toast('图片大小1M以内');
      //     return false
      // }
      return true;
    },
    PicOnlyReady({ file }) {
      // //设置请求头
      // let config = {
      //      headers:{
      //          'Content-Type':'multipart/form-data',
      //          'tenantId': '810011'
      //      }
      // };
      // //this.axios 是因为在main.js写在vue实例里
      // const axiosAjax = this.axios.create({
      //      timeout: 1000 * 60, //时间
      //      withCredentials: true //跨域携带cookie
      // });
      // axiosAjax.post('/wdjob-api/common/put-file',formdata1,config).then((res)=>{   //这里的url为后端接口
      //     console.log(res.data);
      //     //res 为接口返回值
      // }).catch(() => {})
      const formData = new FormData();
      formData.append("file", file, file.name);
      this.module.api.putFile({
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        success: res => {
          this.userInfo.avatar = res.link;
          this.avatarType = false;
        }
      });
    },
    onConfirmBirth(val) {
      const date = moment(this.currentDate).format("YYYY-MM-DD");
      this.whatShow
        ? (this.userInfo.birthday = date)
        : (this.userInfo.workStartTime = date);
      this.selectbirth = false;
    },
    submit() {
      const { birthday, workStartTime } = this.userInfo;
      const userInfo = Object.assign({}, this.userInfo, {
        birthday: moment(birthday).format("YYYY-MM-DD HH:mm:ss"),
        workStartTime: moment(workStartTime).format("YYYY-MM-DD HH:mm:ss")
      });
      this.module.api.personalSubmit({
        params: userInfo,
        success: res => {
          this.toast("保存成功");
          this.onClickLeft();
        },
        error: res => {
          this.toast(res);
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.id && this.onload(this.id);
  }
};
</script>

<style lang="less" scoped>
.user-img {
  position: relative;
  width: 88px;
  margin: 20px auto 40px;
  img {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    object-fit: cover;
  }
  i {
    position: absolute;
    right: 0;
    top: 0;
    color: #2f72f6;
    font-size: 22px;
  }
}
.avatar {
  margin: 10px;
  display: flex;
  flex-wrap: wrap;
  li {
    width: 25%;
    padding: 4px 16px;
    box-sizing: border-box;
    img {
      width: 100%;
      height: auto;
    }
  }
}
/deep/ .van-uploader__input-wrapper {
  width: 100%;
  text-align: center;
}
/deep/.van-cell {
  padding: 20px 16px;
}
/deep/.van-hairline--top-bottom::after,
/deep/.van-hairline-unset--top-bottom::after {
  display: none;
}
/deep/.van-cell__right-icon {
  transform: rotate(90deg);
  top: -4px;
}
.fixed-bottom {
  padding: 10px 16px 20px;
  button {
    flex: 1;
  }
}
/deep/.van-uploader__preview-image,
/deep/.van-uploader__upload {
  border-radius: 50%;
}
/deep/.van-popup {
  border-radius: 0;
}
</style>
